"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stargate_1 = require("@cosmjs/stargate");
const tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
const btclightclientquery = __importStar(require("../../generated/babylon/btclightclient/v1/query"));
const incentivequery = __importStar(require("../../generated/babylon/incentive/query"));
const btc_1 = __importDefault(require("./btc"));
const baby_1 = __importDefault(require("./baby"));
const createClient = async ({ rpcUrl }) => {
    const tmClient = await tendermint_rpc_1.Tendermint34Client.connect(rpcUrl);
    const queryClient = stargate_1.QueryClient.withExtensions(tmClient, stargate_1.setupBankExtension, stargate_1.setupStakingExtension, stargate_1.setupDistributionExtension);
    const rpc = (0, stargate_1.createProtobufRpcClient)(queryClient);
    const incentive = new incentivequery.QueryClientImpl(rpc);
    const btcLight = new btclightclientquery.QueryClientImpl(rpc);
    const bank = (0, stargate_1.setupBankExtension)(queryClient).bank;
    const staking = (0, stargate_1.setupStakingExtension)(queryClient).staking;
    const distribution = (0, stargate_1.setupDistributionExtension)(queryClient).distribution;
    return {
        baby: (0, baby_1.default)({ staking, distribution }),
        btc: (0, btc_1.default)({ incentive, btcLight, bank })
    };
};
exports.default = createClient;
//# sourceMappingURL=index.js.map